var PaymentServiceProvider;
(function(PaymentServiceProvider) {
    PaymentServiceProvider["ADYEN"] = "ADYEN";
    PaymentServiceProvider["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentServiceProvider["FAKE"] = "FAKE";
    PaymentServiceProvider["PAYPAL"] = "PAYPAL";
})(PaymentServiceProvider || (PaymentServiceProvider = {}));
var ExpressPaymentMethod;
(function(ExpressPaymentMethod) {
    ExpressPaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    ExpressPaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    ExpressPaymentMethod["AMAZON_PAY"] = "AMAZON_PAY";
    ExpressPaymentMethod["PAYPAL"] = "PAYPAL";
})(ExpressPaymentMethod || (ExpressPaymentMethod = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethod["BANCONTACT_CARD"] = "BANCONTACT_CARD";
    PaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethod["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentMethod["CREDITCARD"] = "CREDITCARD";
    PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    PaymentMethod["FAKE"] = "FAKE";
    PaymentMethod["IDEAL"] = "IDEAL";
    PaymentMethod["KLARNA"] = "KLARNA";
    PaymentMethod["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
    PaymentMethod["KLARNA_PAY_NOW"] = "KLARNA_PAY_NOW";
    PaymentMethod["MBWAY"] = "MBWAY";
    PaymentMethod["MOBILE_PAY"] = "MOBILE_PAY";
    PaymentMethod["MULTIBANCO"] = "MULTIBANCO";
    PaymentMethod["ONEY"] = "ONEY";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
    PaymentMethod["SWISH"] = "SWISH";
    PaymentMethod["BIZUM"] = "BIZUM";
})(PaymentMethod || (PaymentMethod = {}));
var AdyenBrands;
(function(AdyenBrands) {
    AdyenBrands["VISA"] = 'visa';
    AdyenBrands["MASTERCARD"] = 'mc';
    AdyenBrands["AMEX"] = 'amex';
    AdyenBrands["BANCONTACTMC"] = 'bcmc';
    AdyenBrands["MAESTRO"] = 'maestro';
    AdyenBrands["DANKORT"] = 'dankort';
})(AdyenBrands || (AdyenBrands = {}));

export { AdyenBrands, ExpressPaymentMethod, PaymentMethod, PaymentServiceProvider };
//# sourceMappingURL=cart-payment-methods.js.map
